import { Injectable } from '@angular/core';
import { SessionTimeoutModalComponent } from '../components/session-timeout-modal/session-timeout-modal.component';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
// import { SessionService } from './session.service';

@Injectable()
export class KeepAliveService {
	private TIMEOUT_MILLISECONDS = 9 * 60 * 1000; // 9 * 60 * 1000 is 9 minutes
	private KA_TIMEOUT_MILLISECONDS = 20 * 1000; // 20 * 1000 is 20 seconds
	private sessionTimerID = setTimeout(function () { }, this.TIMEOUT_MILLISECONDS);
	private keepAliveTimerID = setTimeout(function () { }, this.TIMEOUT_MILLISECONDS);
	private req_keep_alive = false;
	private dbounce_keep_alive = false;
	private cookie: CookieService;
	private debug: boolean = false;
	// private http: HttpClient;

	constructor(
		private sTModal: SessionTimeoutModalComponent
		, private http: HttpClient
		, cs: CookieService
	) {
		this.cookie = cs;
	}

	/**
	 * touchSessionTimeout() should be called after the server has kept our session alive.
	 * called from the auth.interceptor on all api 200 responces.
	 * this delays the 9 minute timer that warns the user of a session timeout.
	 */
	touchSessionTimeout() {
		// console.log('restart touchSessionTimeout timer');
		clearTimeout(this.sessionTimerID);
		this.sessionTimerID = setTimeout(() => {
			this.HandleSessionTimeoutTrigger();
		}, this.TIMEOUT_MILLISECONDS);
		this.touchCookieExpiration();
	}

	private HandleSessionTimeoutTrigger() {
		if (this.debug) { console.log("Cleared session timeout"); }
		clearTimeout(this.sessionTimerID);
		this.GetSessionTimeoutInSec().then(resp => {
			if (this.debug) { console.log("Server Timeout in Seconds: ", resp); }
			if (resp <= 60) {
				if (this.debug) { console.log("Server timeout <60s"); }
				//The current timeout on the server is longer than 1 minute
				const sessionTimeoutModal = this.sTModal;
				sessionTimeoutModal.open().subscribe(res => {
					if (res === 'StayloggedIn') {
						this.touch();
					}
				});
			} else {
				//Set the session timer to the server value - 60s (throw up a 60s modal)
				//When timer elapses call same function again
				if (this.debug) { console.log("New session timeout set to: ", (resp * 1000) - (60 * 1000)); }
				this.sessionTimerID = setTimeout(() => {
					if (this.debug) { console.log("Delayed timer triggered"); }
					this.HandleSessionTimeoutTrigger();
				}, (resp * 1000) - (60 * 1000)); //60s delay for the popup
			}
		});
	}


	/**
	 * touch() can be called any time a user makes an action that should keep the session alive.
	 * */
	touch() {
		if (this.dbounce_keep_alive) { 
			if (this.debug) { console.log("debounce keepalive true"); }
			this.req_keep_alive = true;
		} else {
			if (this.debug) { console.log("Calling Keepalive"); }
			this.http.post('api/auth/keepalive', null).subscribe(() => {
				if (this.debug) { console.log("Keepalive returned"); }
				this.touchSessionTimeout();
			});
			this.touchKeepAliveDebouce();
		}
	}

	private touchKeepAliveDebouce() {
		this.dbounce_keep_alive = true;
		clearTimeout(this.keepAliveTimerID);
		this.keepAliveTimerID = setTimeout(() => {
			if (this.req_keep_alive) {
				this.req_keep_alive = false;
				if (this.debug) { console.log("KeepAliveDebounce Timer Ended Posting Keepalive"); }
				this.http.post('api/auth/keepalive', null).subscribe(() => {
					this.touchSessionTimeout();
				});
				this.touchKeepAliveDebouce();
			} else {
				this.dbounce_keep_alive = false;
			}
		}, this.KA_TIMEOUT_MILLISECONDS);
	}

	private touchCookieExpiration() {
		const IsAuthorizedValue = this.cookie.get('IsAuthorized');
		const AccessTokenValue = this.cookie.get('AccessToken');

		const today = new Date(); // Date now.
		const tenMinutes = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate(),
			today.getHours(),
			today.getMinutes() + 12);

		this.cookie.set('IsAuthorized', IsAuthorizedValue, tenMinutes, '/');
		this.cookie.set('AccessToken', AccessTokenValue, tenMinutes, '/');
	}
	/**
	 * Retrieves the server side time left in MS.
	 * @returns Seconds left in the server side timeout
	 */
	private GetSessionTimeoutInSec(): Promise<number> {
		let url = "api/auth/GetTimeout/";
		return this.http.get<number>(url).toPromise<number>();
	}
}
